import { computed } from 'vue';
import { useTaxStore } from '~/stores/tax';

export function useTaxCalculation(netPrice: number, type: 'post' | 'subscription' = 'post') {
    const { rates } = useTaxStore();
    
    const taxRate = computed(() => {
        return type === 'post' ? rates.post : rates.subscription;
    });

    const subtotal = computed(() => {
        // Net price is our subtotal
        return Number(netPrice.toFixed(2));
    });

    const vat = computed(() => {
        // Calculate VAT based on net price and tax rate
        if (!taxRate.value) return 0;
        return Number((netPrice * taxRate.value).toFixed(2));
    });

    const total = computed(() => {
        return Number((subtotal.value + vat.value).toFixed(2));
    });

    return {
        subtotal,
        vat,
        total,
        taxRate
    };
}
